// extracted by mini-css-extract-plugin
export var active = "_5x-b";
export var activeIndicator = "_5x-6";
export var animate = "_5x-a";
export var disabled = "_5x-c";
export var flat = "_5x-1";
export var fullWidth = "_5x-3";
export var lg = "_5x-9";
export var md = "_5x-8";
export var redoButtonTabGroup = "_5x-0";
export var sm = "_5x-7";
export var tabButton = "_5x-4";
export var tabButtonsContainer = "_5x-2";
export var xs = "_5x-5";